import {
  FIRST_TOUCH_COOKIE,
  FIRST_TOUCH_TTL_DAYS,
} from "~/feature/attribution/constants";
import type { IFirstTouch, ILandingVisit } from "~/feature/attribution/type";
import { resolveFirstTouch } from "~/feature/attribution/utils/firstTouch";
import { parseFirstTouch } from "~/feature/attribution/utils/parseFirstTouch";
import { readCookie, removeCookie, writeCookie } from "~/utils/cookieValue";

const listeners = new Set<() => void>();

export const subscribeToFirstTouch = (listener: () => void): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const notifyListeners = (): void => {
  listeners.forEach((listener) => listener());
};

export const readFirstTouchCookie = (): string | null =>
  readCookie(FIRST_TOUCH_COOKIE);

const writeFirstTouch = (firstTouch: IFirstTouch): void => {
  writeCookie(
    FIRST_TOUCH_COOKIE,
    JSON.stringify(firstTouch),
    FIRST_TOUCH_TTL_DAYS
  );
  notifyListeners();
};

const removeFirstTouch = (): void => {
  removeCookie(FIRST_TOUCH_COOKIE);
  notifyListeners();
};

export const captureFirstTouch = (landing: ILandingVisit): void => {
  const stored = parseFirstTouch(readFirstTouchCookie());
  const firstTouch = resolveFirstTouch(stored, landing);

  if (firstTouch === stored) {
    return;
  }

  if (firstTouch) {
    writeFirstTouch(firstTouch);
    return;
  }

  removeFirstTouch();
};
